/**
 * Hook for checking if tenant sync feature is enabled
 */
import { TenantSyncConfig } from '../config';
import Service from '@/lib/App';

/**
 * Returns whether the tenant sync feature is enabled based on feature flag
 * Uses sessionStorage-based feature flags from CacheService
 */
export function useTenantSyncEnabled(config: TenantSyncConfig): boolean {
  return Service.cache.isFeatureFlagOn(config.featureFlagKey);
}
